"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalTransitionContextProvider = exports.ModalTransitionContextConsumer = exports.ModalTransitionContext = exports.defaultModalTransitionContext = void 0;

var _react = require("react");

var defaultModalTransitionContext = {
  transitioning: false
};
exports.defaultModalTransitionContext = defaultModalTransitionContext;
var ModalTransitionContext = (0, _react.createContext)(defaultModalTransitionContext);
exports.ModalTransitionContext = ModalTransitionContext;
var ModalTransitionContextConsumer = ModalTransitionContext.Consumer,
    ModalTransitionContextProvider = ModalTransitionContext.Provider;
exports.ModalTransitionContextProvider = ModalTransitionContextProvider;
exports.ModalTransitionContextConsumer = ModalTransitionContextConsumer;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/context/ModalTransitionContext.js
// module id = 116
// module chunks = 0